var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "input-mobile" },
      [
        _c(
          "vh-form",
          { ref: "phoneForm", attrs: { rules: _vm.rules, model: _vm.form } },
          [
            _c(
              "vh-form-item",
              { attrs: { prop: "phone" } },
              [
                _c("vh-input", {
                  staticClass: "input",
                  attrs: {
                    placeholder: _vm.$t("login.login_1044"),
                    disabled: _vm.isReplay,
                  },
                  model: {
                    value: _vm.form.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "phone", $$v)
                    },
                    expression: "form.phone",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.value.ext.edit && !_vm.isReplay
          ? _c(
              "div",
              { staticClass: "ruleTip" },
              [
                _c("span", [_vm._v("短信验证")]),
                _vm._v(" "),
                _c("vh-switch", {
                  staticClass: "switch",
                  attrs: {
                    "active-color": "#FB3A32",
                    "inactive-color": "#CECECE",
                    size: "mini",
                    width: 32,
                  },
                  model: {
                    value: _vm.phoneValide,
                    callback: function ($$v) {
                      _vm.phoneValide = $$v
                    },
                    expression: "phoneValide",
                  },
                }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.phoneValide ? "已开启" : "开启后") +
                      "，将对手机号进行国内号段校验及验证码验证"
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.phoneValide && _vm.isPreview && !_vm.isReplay
          ? _c("div", { class: _vm.isH5 ? "vertify_wap" : "vertify" }, [
              _c("div", { attrs: { id: "captcha" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vertify_code" },
                [
                  _c("vh-input", {
                    staticClass: "input",
                    attrs: {
                      type: "text",
                      maxlength: "6",
                      placeholder: _vm.$t("login.login_1045"),
                    },
                    model: {
                      value: _vm.phoneCode,
                      callback: function ($$v) {
                        _vm.phoneCode = $$v
                      },
                      expression: "phoneCode",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "vh-button",
                    {
                      staticClass: "code-btn",
                      class: { red: _vm.vertify_pass && _vm.phoneKey },
                      attrs: {
                        size: "small",
                        type: "info",
                        disabled: !_vm.vertify_pass || !_vm.phoneKey,
                      },
                      on: { click: _vm.getCaptha },
                    },
                    [_vm._v(_vm._s(_vm.butText))]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }